import { gql } from '@apollo/client';

const JOYRIDE_FIELDS = `
    id
    name
    startDate
    endDate
    challenge
    target
    challengeTeamUrl
    archivedAt
    isLive
`;

/** Edits a campaign in place. With an id, edits that one (archived included). */
export const SET_JOYRIDE = gql`
    mutation SetJoyride($id: Int, $name: String, $startDate: String, $endDate: String, $challenge: String, $target: Int, $challengeTeamUrl: String) {
        setJoyride(id: $id, name: $name, startDate: $startDate, endDate: $endDate, challenge: $challenge, target: $target, challengeTeamUrl: $challengeTeamUrl) {
            ${JOYRIDE_FIELDS}
        }
    }
`;

/** Starts a new campaign, archiving whichever one is currently live. */
export const CREATE_JOYRIDE = gql`
    mutation CreateJoyride($name: String, $startDate: String, $endDate: String, $challenge: String, $target: Int, $challengeTeamUrl: String) {
        createJoyride(name: $name, startDate: $startDate, endDate: $endDate, challenge: $challenge, target: $target, challengeTeamUrl: $challengeTeamUrl) {
            ${JOYRIDE_FIELDS}
        }
    }
`;

/** Puts an archived campaign back on display, archiving the current live one. */
export const ACTIVATE_JOYRIDE = gql`
    mutation ActivateJoyride($id: Int!) {
        activateJoyride(id: $id) {
            ${JOYRIDE_FIELDS}
        }
    }
`;

/** Retires a campaign without replacing it. */
export const ARCHIVE_JOYRIDE = gql`
    mutation ArchiveJoyride($id: Int!) {
        archiveJoyride(id: $id) {
            ${JOYRIDE_FIELDS}
        }
    }
`;
